export default __webpack_public_path__ + "static/media/Anuphan-SemiBold.c9569649.eot";